import React from "react";
import SearchMobile$ from "@deosite/components-new/SearchMobile";
import InputBare from "../formControls/input/InputBare";

const SearchMobile = props => {
  const propsExt = {
    ...props,
    inputBare: <InputBare sx={{ width: "100%" }} />
  };
  return <SearchMobile$ {...propsExt} />;
};

export default SearchMobile;
